import React, { useEffect, useRef, useState } from "react";
import { useDroppable } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { SortableItem } from "./";
import { Dropdown, Tooltip } from "antd";
import { MoreVert, DragIndicator } from "@mui/icons-material";

export default function Container({
  id,
  items,
  tasks,
  status,
  statuses,
  setStatuses,
  deletePreviewHandler,
  addTaskPreviewHandler,
  taskDetailHandler,
}) {
  // STATES
  const [selectedColumn, setSelectedColumn] = useState(null);
  const [editInputIndex, setEditInputIndex] = useState(-1);
  const [editInputValue, setEditInputValue] = useState("");

  // CONST VALS
  const { http } = global.services;
  const editInputRef = useRef(null);
  const { setNodeRef } = useDroppable({
    id,
  });

  // HANDLERS
  const editColumnPreviewHandler = (item) => {
    setSelectedColumn(item);
    setEditInputValue(item.name);
    setEditInputIndex(item.id);
  };

  const updateColumnHandler = () => {
    const oldVal = statuses.find((x) => x.id === editInputIndex).name;
    setEditInputIndex(-1);
    if (editInputValue === oldVal || editInputValue === "") return;
    http
      .put(`company-board/${selectedColumn.id}`, { name: editInputValue })
      .then(() => {
        setEditInputValue("");
        setSelectedColumn(null);
        setStatuses(
          statuses.map((x) =>
            x.id === editInputIndex ? { ...x, name: editInputValue } : x
          )
        );
      })
      .catch(() => {});
  };

  // HOOKS
  useEffect(() => {
    editInputRef.current?.focus();
  }, [editInputIndex]);

  return (
    <>
      <div className="status-cards" ref={setNodeRef}>
        <div className="title-col">
          <DragIndicator className="drag-handle" />
          {editInputIndex === status.id ? (
            <input
              ref={editInputRef}
              value={editInputValue}
              onChange={(e) => setEditInputValue(e.target.value)}
              onBlur={updateColumnHandler}
              onKeyDown={(e) => {
                if (e.key === " ") {
                  e.stopPropagation(); // prevents DnD from capturing the space key
                }
                if (e.key === "Enter") {
                  updateColumnHandler();
                }
              }}
            />
          ) : (
            <span onDoubleClick={() => editColumnPreviewHandler(status)}>
              {status.name.length > 20 ? (
                <Tooltip title={status.name}>{status.name.slice(0, 20) + "..."}</Tooltip>
              ) : (
                status.name
              )}
            </span>
          )}
          <Dropdown
            menu={{
              items: [
                {
                  key: "0",
                  onClick: () => editColumnPreviewHandler(status),
                  label: <span>Rename</span>,
                },
                {
                  type: "divider",
                },
                {
                  key: "1",
                  onClick: deletePreviewHandler,
                  label: <span>Delete</span>,
                },
              ],
            }}
            trigger={["click"]}
            overlayClassName="status-action-dropdown"
            getPopupContainer={(trigger) => trigger.parentNode}
          >
            <MoreVert className="action-btn" />
          </Dropdown>
        </div>
        <div className="dropable-container">
          <SortableContext id={id} items={items} strategy={verticalListSortingStrategy}>
            {items.map((id, index) => (
              <SortableItem
                key={index}
                id={id}
                data={tasks.find((x) => x.id === id)}
                taskDetailHandler={taskDetailHandler}
              />
            ))}
            <button className="add-task-btn" onClick={addTaskPreviewHandler}>
              Add task
            </button>
          </SortableContext>
        </div>
      </div>
    </>
  );
}
